import { Controller } from "stimulus";

export default class extends Controller {
  toggleDropdown(e) {
    e.target.classList.toggle("-is-open");
  }
}
